import styled from "styled-components";

export const BackToPodeMorarText = styled.div`
  font-size: 14px;
  color: #4d4d4d;
  text-align: center;
  font-weight: bold;
  margin-top: 36px;
`;

export const ButtonContainer = styled.div`
  margin-top: 40px;
`;

export const ErrorLoginMessage = styled.span`
  color: #b91c1c;
  margin-top: 20px;
  display: block;
  text-align: center;
`;
